import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { ToastsContainer, ToastsStore } from 'react-toasts';
import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import ShipDHLList from './ShipDHLList';

class ShipDHL extends Component {
  constructor() {
    super();

    this.state = {
    };
  }

  loadDHL() {
    WorkOrderDataService.retrieveDHL().then(data => {
      if (data !== undefined && data !== null) {
        this.setState({ dhl: data })
      }
    });
  }

  componentDidMount() {
    //this.loadDHL();
  }

  render() {
    if (!AuthenticationService.isShipping()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <ShipDHLList/>
        <br />
      </div>
    )
  }
}
export default withRouter(ShipDHL);